export const NAVIGATION_ITEM_CLASS = [
    'flex items-center gap-2 rounded-[8px] p-[10px] my-2 relative w-full text-left text-base',
    'hover:bg-overlay-white-30 cursor-pointer transition-colors duration-200',
    "after:content-[''] after:absolute after:-bottom-1 after:left-0",
    'after:w-full after:h-[1px] after:bg-overlay-white-10',
].join(' ');

export const NAVIGATION_ACTIVE_ITEM_CLASS = [
    'whitespace-nowrap',
    NAVIGATION_ITEM_CLASS,
    'bg-brand-primary hover:bg-brand-primary',
].join(' ');

export const NAVIGATION_LAST_ITEM_CLASS = 'after:content-[none]';

export const NAVIGATION_DROPDOWN_TRIGGER_CLASS = [
    'px-3 py-3 rounded-[8px] cursor-pointer flex items-center',
    'transition-colors text-content-on-dark duration-300',
].join(' ');

export const NAVIGATION_DROPDOWN_PANEL_CLASS = 'px-[10px] pt-1 pb-[0.5px] bg-surface-dark rounded-[8px]';
